/* eslint angular/component-limit:0, angular/file-name:0 */
/**
                                                             * PaymentController
                                                             * @namespace gplans.store.controllers
                                                             */
(function () {
  'use strict';

  /* eslint-disable angular/one-dependency-per-line, angular/controller-name, angular/function-type, angular/di */PaymentController.$inject = ["$analytics", "$anchorScroll", "$cookies", "$http", "$localStorage", "$location", "$rootScope", "$sce", "$scope", "$state", "$stateParams", "$timeout", "$uibModal", "$window", "$q", "Authentication", "Profile", "Snackbar", "currency", "gplansConf", "mesSystem", "Mealplan", "MeasurementSystem", "Survey", "UserService"];
  angular.
  module('gplans.store.controllers').
  controller('ExitPopupModalInstanceCtrl', ["$localStorage", "$uibModalInstance", function ($localStorage, $uibModalInstance) {
    var vm = this;
    vm.close = close;
    vm.getDiscountedPlan = _wrapGetPlan;

    function close() {
      $uibModalInstance.dismiss('close');
    }

    function _wrapGetPlan() {
      $uibModalInstance.dismiss('close');
      $localStorage.week_trial = true;
    }
  }]).
  controller('PaymentController', PaymentController);
  /* eslint-enable angular/one-dependency-per-line, angular/controller-name, angular/function-type, angular/di */

  PaymentController.$inject = ['$analytics', '$anchorScroll', '$cookies', '$http', '$localStorage', '$location', '$rootScope', '$sce', '$scope', '$state',
  '$stateParams', '$timeout', '$uibModal', '$window', '$q', 'Authentication', 'Profile', 'Snackbar', 'currency', 'gplansConf', 'mesSystem',
  'Mealplan', 'MeasurementSystem', 'Survey', 'UserService'];

  /**
                                                              * @namespace PaymentController
                                                              */
  function PaymentController($analytics, $anchorScroll, $cookies, $http, $localStorage, $location, $rootScope, $sce, $scope, $state, $stateParams,
  $timeout, $uibModal, $window, $q, Authentication, Profile, Snackbar, currency, gplansConf, mesSystem,
  Mealplan, MeasurementSystem, Survey, UserService) {
    var vm = this;
    vm.customer = {};
    vm.order = {};
    vm.place = null;
    vm.popoverContent = $sce.trustAsHtml('<img src="images/cvn.gif"/>');
    vm.week_trial = $localStorage.week_trial;
    vm.alreadySubscribed = false;
    vm.planSlug = $stateParams.plan || $localStorage['plan'] || gplansConf.defaultPlan;
    vm.mesSystem = mesSystem;
    vm.oldPaymentForm = false;
    vm.loading = false;
    vm.submit = submit;
    vm.gotoUpsell = gotoUpsell;
    vm.getPaypalTokenRequest = getPaypalTokenRequest;
    vm.onPaypalSuccess = onPaypalSuccess;
    vm.onBraintreeSuccess = onBraintreeSuccess;
    vm.authorizeSubmit = authorizeSubmit;
    vm.authorizeSubmitOldForm = authorizeSubmitOldForm;
    vm.onRecurlySuccess = onRecurlySuccess;
    vm.recurlySubmit = recurlySubmit;
    vm.recurlySubmitOldForm = recurlySubmitOldForm;
    vm.freeSubmit = freeSubmit;
    vm.changePlan = changePlan;
    var modalInstance;

    activate();

    function activate() {

      vm.user = UserService.data;

      /*
                                  angular.element($window).on('beforeunload', function(e){
                                    _showExitPopup();
                                    var text = "If you leave this page, data may be lost.";
                                    e.returnValue = text;
                                    return text;
                                  });
                                  */

      $scope.$on('$destroy', cleanUp);

      Authentication.check().then(function (res) {
        vm.alreadySubscribed = !!UserService.data['subscription_plan'];
        if (vm.alreadySubscribed) cleanUp(); // don't show exit popup if user is already subscribed
        vm.customer = { email: UserService.data.email };
        vm.metabolic_type = UserService.data.meal_plan.metabolic_type;
        getPlan(vm.planSlug).then(function (res) {
          vm.plan = res.data;
          vm.customer.campaign_id = res.data.campaign_id;

          $(window).load(function () {
            $("#cc_number").mask("9999 9999 9999 999?9 999999", { placeholder: " " });
          });

          $timeout(function () {
            $("#cc_number").mask("9999 9999 9999 999?9 999999", { placeholder: " " });
          }, 500);


        });
      }, function (err) {
        $state.go('base.store_payment_before_quiz');
      });

      $scope.$watch('vm.place', function (place) {
        if (!place || !angular.isDefined(place.address_components)) return;
        // Get each component of the address from the place details
        // and fill the corresponding field on the form.
        vm.customer.address = '';
        for (var i = 0; i < place.address_components.length; i++) {
          var part = place.address_components[i];
          var type = part.types[0];
          if ('street_number' === type) {
            vm.customer.address += part.short_name;
          } else if ('route' === type) {
            vm.customer.address += ' ' + part.short_name;
            vm.addressLookupSuccess = true;
          } else if ('locality' === type) {
            vm.customer.city = part.long_name;
          } else if ('administrative_area_level_1' === type) {
            vm.customer.state = part.short_name;
          } else if ('country' === type) {
            vm.customer.country = part.short_name;
          } else if ('postal_code' === type) {
            vm.customer.postal_code = part.long_name;
          }
        }
      });

      if (currency == 'GBP') {
        vm.currencySymbol = '£';
      } else if (currency == 'AUD' || currency == 'CAD') {
        vm.currencySymbol = currency + '$';
      } else {
        vm.currencySymbol = '$';
      }

      $analytics.eventTrack('Payment');

      vm.looseWeight = UserService.data.current_weight - UserService.data.goal_weight;
      vm.goalWeight = UserService.data.goal_weight;
      if (mesSystem == 'SI') {
        vm.weightUnit = 'kg';
        vm.looseWeight = Math.round(MeasurementSystem.convertLbsToKg(vm.looseWeight));
        vm.goalWeight = Math.round(MeasurementSystem.convertLbsToKg(vm.goalWeight));
      } else
      {
        vm.weightUnit = 'pounds';
      }

      vm.problems = {};
      var metaPromise =
      $http.get(gplansConf.API_URL + '/api/v1/metabolictypes/' + UserService.data.last_checkin.metabolic_type + '/');
      var surveyPromise =
      Survey.getAnswers(UserService.data.user_survey_id);
      $q.all([
      metaPromise,
      surveyPromise]).
      then(function (res) {
        vm.metabolic_type = res[0].data;

        vm.userSurveyAnswers = res[1].userSurveyAnswers;

        vm.problems = res[1].problems;

        if (vm.problems['restrictions']) {
          if (vm.problems['restrictions'].indexOf('paleo') > -1) {
            vm.restrictionTitle = 'Paleo Diet';
          }
          if (vm.problems['restrictions'].indexOf('vegan') > -1) {
            vm.restrictionTitle = 'Vegan Diet';
          }
          if (vm.problems['restrictions'].indexOf('vegetarian') > -1) {
            vm.restrictionTitle = 'Vegetarian Diet';
          }
          if (vm.problems['restrictions'].indexOf('pescetarian') > -1) {
            vm.restrictionTitle = 'Pescetarian Diet';
          }
        }

        vm.showProblemsBlock = vm.problems['energy'] === 'low energy' ||
        vm.problems['mood'] === 'mood swings' ||
        vm.problems['heart'] === 'heart disease' ||
        vm.problems['diabetes'] === 'diabetes' ||
        vm.problems['stomach'] === 'stomach discomfort';

        if (vm.restrictionTitle) {
          vm.metabolicTitle = vm.metabolic_type.name + ' (' + vm.restrictionTitle + ')';
        } else {
          vm.metabolicTitle = vm.metabolic_type.name;
        }
      });
    }

    function gotoUpsell() {
      $state.go('base.store_upsell', { plan: vm.planSlug });
    }

    function cleanUp() {
      angular.element($window).off('beforeunload');
    }

    function _showExitPopup() {
      modalInstance = $uibModal.open({
        animation: true,
        size: 'md',
        templateUrl: 'templates/store/exit-popup.modal.html',
        controller: 'ExitPopupModalInstanceCtrl',
        controllerAs: 'vm' });

      modalInstance.result.then(function (res) {
        console.log(res);
      }, function (res) {
        console.log(res);
      })['finally'](function () {
        // we should null modal in case we receive popUp twice somehow
        modalInstance = undefined;
        vm.week_trial = $localStorage.week_trial;
      });
    }

    function getPlan(planSlug) {
      var req = $http({
        url: gplansConf.API_URL + '/api/v1/plans/' + planSlug + '/',
        method: "GET" });

      return req;
    }

    function getPaypalTokenRequest() {
      return {
        method: 'post',
        url: gplansConf.API_URL + '/api/v1/paypal/agreement/create/',
        json: {
          plan: vm.planSlug,
          order_bump: !!vm.orderBump,
          week_trial: !!$localStorage.week_trial } };



    }

    function onPaypalSuccess(response) {
      var paymentToken = response.paymentToken;
      vm.paypalPaymentToken = paymentToken;
      vm.customer.first_name = 'Pay';
      vm.customer.last_name = 'Pal';
      vm.customer.payment_method = $localStorage['payment_method'] = 'PAYPAL';
      Profile.createCustomer(vm.customer).then(customerSuccess, customerError);
    }

    function onBraintreeSuccess(response) {
      vm.braintreePaymentToken = response.nonce;
      if (response.type == "PayPalAccount") {
        vm.customer.first_name = response.details.firstName;
        vm.customer.last_name = response.details.lastName;
      } else
      {
        vm.customer.first_name = 'Braintree';
        vm.customer.last_name = 'Cardholder';
      }
      vm.customer.payment_method = $localStorage['payment_method'] = 'BRAINTREE';
      Profile.createCustomer(vm.customer).then(customerSuccess, customerError);
    }


    function onRecurlySuccess(response) {
      vm.recurlyToken = response.token;
      vm.customer.first_name = UserService.data.first_name;
      vm.customer.last_name = UserService.data.last_name ? UserService.data.last_name : UserService.data.first_name;
      vm.customer.payment_method = $localStorage['payment_method'] = 'RECURLY';
      Profile.createCustomer(vm.customer).then(customerSuccess, customerError);
    }

    function orderSuccess(res) {
      vm.orderId = res && res.data ? res.data.order_id : '';
      vm.orderSuccess = true;
      vm.orderSubmitting = false;

      if ($rootScope.user && $rootScope.user.intercom_id) {
        $analytics.setAlias($rootScope.user.intercom_id);
      }
      if (window.fbq) {
        fbq('track', 'Purchase', { value: '39.00', currency: 'USD' });
        fbq('track', 'Search', { value: '39.00', currency: 'USD' });
      }
      if (window.fbq && vm.orderBump) fbq('track', 'Search', { currency: 'USD', value: 10 });

      // HJ Plan Purchased
      if ($window.hj) {
        hj('vpv', 'Plan Purchased');
      }

      // VWO
      $window.VWO = $window.VWO || [];
      $window.VWO.push(['track.revenueConversion', "39"]);
      if (vm.orderBump) $window.VWO.push(['track.revenueConversion', "10"]);

      var props = {};
      var planName = vm.plan ? vm.plan['name'] : gplansConf.defaultPlan;
      props['Plan ' + planName + ' Purchased'] = 'Plan ' + planName;
      props['Payment Method'] = $localStorage['payment_method'];

      $analytics.eventTrack('Plan Purchased', props);
      if ($localStorage['payment_method'] == 'PAYPAL') {
        $analytics.eventTrack('PayPal Purchase');
      }
      // we need to update plans after order create, b/c default plan - free
      Mealplan.updatePlans();

      $timeout(function () {
        Authentication.check().then(function () {
          // TODO: add some logic here if we don't want always to upsell probably
          if (false) {
            $state.go('base.store_upsell', { plan: vm.planSlug });
          } else {
            $state.go('base.store_account_info', { plan: vm.planSlug });
          }
          //top.location.href = '/app';
          // $state.go('gplans.userConsole');
          //$state.go('gplans.userConsole', {intro:'intro'}, { reload: true });
        });
      }, 3000);
    }


    function orderError(err) {
      //vm.paymentForm.cc_number.$setValidity('stripeToken', false);
      vm.loading = false;
      vm.orderSubmitting = false;
      Snackbar.error(err.data.payment);
    }

    function customerError(err) {
      vm.orderSubmitting = false;
      vm.loading = false;
      Snackbar.error(err.data.detail);
    }

    function customerSuccess(res) {
      // save  order_bump for future using in upsellBundle
      $localStorage.order_bump = vm.orderBump;

      // Success of createCustomer
      // Now create order
      var oOrder = {};
      vm.orderSubmitting = true;
      oOrder.customer = res.data.id;
      oOrder.campaign_id = res.data.campaign_id || 1;
      oOrder.product_id = vm.plan.product_id;
      oOrder.plan = vm.plan.id;
      if ($localStorage.week_trial) {
        oOrder.week_trial = true;
      }
      oOrder.stripe_token = vm.stripe_token;
      oOrder.order_bump = vm.orderBump;
      oOrder.paypal_token = vm.paypalPaymentToken;
      oOrder.braintree_token = vm.braintreePaymentToken;
      if (vm.oldPaymentForm) {
        oOrder.order = vm.order;
      } else
      if ($localStorage['payment_method'] == 'AUTHORIZE' || $localStorage['payment_method'] == 'RECURLY') {
        oOrder.order = {};
        oOrder.order.expiration = {};
        var expiration = vm.order.expiry.replace(/\s/g, '').split('/');
        oOrder.order.expiration.month = expiration[0];
        oOrder.order.expiration.year = expiration[1];
        oOrder.order.cc_number = vm.order.number;
        oOrder.order.cvv = vm.order.cvv;
      }
      oOrder.recurly_token = vm.recurlyToken;
      Profile.createOrder(oOrder).then(orderSuccess, orderError);
    }

    function customerFreeSuccess(res) {
      var oOrder = {};
      vm.orderSubmitting = true;
      oOrder.customer = res.data.id;
      oOrder.campaign_id = res.data.campaign_id;
      oOrder.product_id = vm.plan.product_id;
      oOrder.plan = vm.plan.id;
      if ($localStorage.week_trial) {
        oOrder.week_trial = true;
      }
      oOrder.free_token = UserService.data.uid;
      oOrder.order_bump = vm.orderBump;
      console.log(oOrder);
      Profile.createOrder(oOrder).then(orderSuccess, orderError);
    }

    function freeSubmit() {
      vm.customer.payment_method = 'FREE';
      $localStorage['payment_method'] = 'FREE';
      Profile.createCustomer(vm.customer).then(customerFreeSuccess, customerError);
    }

    function submit() {
      vm.showValidation = true;
      if (vm.paymentForm.$valid) {
        vm.orderSubmitting = true;

        Stripe.setPublishableKey(gplansConf.STRIPE_KEY);
        Stripe.card.createToken({
          number: vm.order.cc_number,
          cvc: vm.order.cvv,
          exp_month: vm.order.expiration.month,
          exp_year: vm.order.expiration.year },
        stripeResponseHandler);
      } else {
        $location.hash("first_name");
        $anchorScroll();
      }
    }

    function authorizeSubmit(result) {
      vm.showValidation = true;
      vm.orderSubmitting = true;
      vm.customer.payment_method = $localStorage['payment_method'] = 'AUTHORIZE';
      vm.customer.first_name = 'Authorize';
      vm.customer.last_name = 'Cardholder';
      vm.order = result;
      Profile.createCustomer(vm.customer).then(customerSuccess, customerError);
    }

    function recurlySubmit(result) {
      vm.showValidation = true;
      vm.orderSubmitting = true;
      vm.customer.payment_method = $localStorage['payment_method'] = 'RECURLY';
      vm.customer.first_name = UserService.data.first_name;
      vm.customer.last_name = UserService.data.last_name ? UserService.data.last_name : UserService.data.first_name;
      vm.order = result;
      Profile.createCustomer(vm.customer).then(customerSuccess, customerError);
    }

    function authorizeSubmitOldForm() {
      vm.showValidation = true;
      vm.oldPaymentForm = true;
      if (vm.paymentForm.$valid) {
        vm.orderSubmitting = true;
        vm.customer.payment_method = $localStorage['payment_method'] = 'AUTHORIZE';
        Profile.createCustomer(vm.customer).then(customerSuccess, customerError);
      } else {
        $location.hash("first_name");
        $anchorScroll();
      }
    }

    function recurlySubmitOldForm() {
      vm.showValidation = true;
      vm.oldPaymentForm = true;
      if (vm.paymentForm.$valid) {
        vm.orderSubmitting = true;
        vm.customer.payment_method = $localStorage['payment_method'] = 'RECURLY';
        Profile.createCustomer(vm.customer).then(customerSuccess, customerError);
      } else {
        $location.hash("first_name");
        $anchorScroll();
      }
    }

    function stripeResponseHandler(status, response) {
      if (response.error) {// Problem!
        vm.orderSubmitting = false;
        vm.paymentForm.cc_number.$setValidity('stripeToken', false);
        Snackbar.error(response.error.message);
      } else {// Token was created!
        // Get the token ID:
        vm.stripe_token = response.id;
        vm.customer.payment_method = $localStorage['payment_method'] = 'STRIPE';
        Profile.createCustomer(vm.customer).then(customerSuccess, customerError);
      }
    }

    function changePlan(planSlug) {
      getPlan(planSlug).then(function (res) {
        vm.plan = res.data;
        vm.customer.campaign_id = res.data.campaign_id;
      });
    }
  }
})();